interface CirclesConnectedSVGProps {
  color: string;
  style: React.CSSProperties;
}

const CirclesConnectedSVG = ({ color, style }: CirclesConnectedSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
  >
    <g clipPath="url(#clip0_955_12392)">
      <path
        d="M13.2775 25.9999C13.2775 33.0278 18.9721 38.7225 26 38.7225C33.028 38.7225 38.7226 33.0278 38.7226 25.9999C38.7226 18.972 33.028 13.2773 26 13.2773C18.9721 13.2773 13.2775 18.972 13.2775 25.9999Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2774 25.9999H6.91473"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.7225 25.9999H45.0852"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 38.7227V42.9654"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 13.2775V9.03479"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.9647 12.0351C41.6209 13.6914 44.3068 13.6914 45.963 12.0351C47.6192 10.3789 47.6192 7.69307 45.963 6.03685C44.3068 4.38062 41.6209 4.38062 39.9647 6.03685C38.3085 7.69307 38.3085 10.3789 39.9647 12.0351Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.03697 39.9648C4.38074 41.6211 4.38074 44.3069 6.03697 45.9631C7.6932 47.6194 10.379 47.6194 12.0353 45.9631C13.6915 44.3069 13.6915 41.6211 12.0353 39.9648C10.379 38.3086 7.6932 38.3086 6.03697 39.9648Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.41538 11.4142C4.89972 13.8986 8.92987 13.8986 11.4142 11.4142C13.8986 8.92987 13.8986 4.89972 11.4142 2.41538C8.92987 -0.068961 4.89972 -0.068961 2.41538 2.41538C-0.068961 4.89972 -0.068961 8.92987 2.41538 11.4142Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5858 49.5847C43.0701 52.0691 47.1003 52.0691 49.5846 49.5847C52.069 47.1004 52.069 43.0703 49.5846 40.5859C47.1003 38.1016 43.0701 38.1016 40.5858 40.5859C38.1014 43.0703 38.1014 47.1004 40.5858 49.5847Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.9648 12.0353L34.9961 17.004"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0353 39.9648L17.004 34.9961"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4142 11.4141L17.004 17.0038"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5859 40.5859L34.9823 34.9823"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_955_12392">
        <rect width="52" height="52" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default CirclesConnectedSVG;
